import { faBuilding, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/Typography';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { Client } from '@/data/models/client.interface';
import { Tenant } from '@/data/models/tenant.interface';

interface CardClientProps {
  client: Client;
  tenant: Tenant;
}

export const CardClient = ({ client, tenant }: CardClientProps) => {
  const { t } = useTranslation();
  const address = client.postal_address;

  return (
    <div className='flex flex-col gap-4 rounded-xl border bg-card p-4'>
      <div className='flex flex-wrap items-center justify-between gap-3'>
        <div className='flex min-w-0 items-center gap-3'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary'>
            <FontAwesomeIcon icon={faBuilding} />
          </div>
          <div className='min-w-0'>
            <Typography variant='h4'>{client.name}</Typography>
            {client.legal_id && (
              <Typography variant='paragraphMini' color='muted'>
                {t('dashboard.pixid.client.legal_id')}: {client.legal_id}
              </Typography>
            )}
          </div>
        </div>
        <Badge variant='secondary'>{tenant.label}</Badge>
      </div>

      <Separator />

      <div className='flex flex-wrap items-center gap-3'>
        <FontAwesomeIcon icon={faLocationDot} className='text-primary' />
        <Typography variant='paragraphSmall' className='min-w-0 flex-1'>
          {t('dashboard.pixid.client.address')}: {address?.address}{' '}
          {address?.city} {address?.postal_code} {address?.country_code}
        </Typography>
        {address?.country_code && (
          <Badge variant='outline'>{address.country_code}</Badge>
        )}
      </div>
    </div>
  );
};
